export default __webpack_public_path__ + "static/03-162e6e5c652bcfcfe412ec9b06ef824e.png";